export const wait = (ms?: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const saveFile = async (
  url: string,
  filename: string,
  waitTime = 1000
) => {
  await wait(waitTime);

  // Get file name from url
  filename = filename
    ? url.substring(url.lastIndexOf("/") + 1).split("?")[0]
    : "Sked";

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.responseType = "blob";
    xhr.onload = function () {
      // A request to download_url may return HTTP 400 telling us that the PDF
      // is not yet ready to be downloaded, so we poll the url at progressively
      // longer intervals until we get the PDF file.
      if (xhr.status !== 200) {
        if (waitTime >= 16000) reject(new Error("Failed to save PDF"));
        saveFile(url, filename, waitTime * 2)
          .then((result) => resolve(result))
          .catch((error) => reject(error));
      } else {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = filename;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href); // Safe to revoke - download already initiated
        resolve(null);
      }
    };
    xhr.open("GET", url);
    xhr.send();
  });
};
